<div id="print-section" class="procuracao">
  <h1>PROCURAÇÃO</h1>

  <p>
    <strong><u>OUTORGANTE 1:</u> {{ proprietario?.name }}</strong>, nacionalidade brasileiro(a), natural de
    {{ proprietario?.naturalidade || '' }}, portador CPF nº {{ proprietario?.cpf ? (proprietario.cpf | mask:
    '000.000.000-00') : ''}}, e identidade {{ proprietario?.rg?.number || '' }}, domiciliado e residente à
    {{ imovel?.address?.street || '' }}, {{ imovel?.address?.number || '' }},
    {{ imovel?.address?.zipCode ? (imovel?.address?.zipCode | mask: '00000-000') : '' }},
    {{ imovel?.address?.city || '' }},
    telefone: {{ proprietario?.phones?.cellphone ? (proprietario.phones.cellphone | mask: '(00) 00000-0000') : ''}},
    E-mail: {{proprietario?.email}}
  </p>

  <p *ngIf="mostrarDadosConjuge">
    <strong><u>OUTORGANTE 2:</u> {{ conjuge?.name || '' }}</strong>, nacionalidade brasileiro(a), natural de
    {{ conjuge?.naturalidade || '' }}, portador CPF nº {{ conjuge?.cpf ? (conjuge.cpf | mask: '000.000.000-00') : '' }},
    e identidade {{ conjuge?.rg?.number || '' }}, domiciliado e residente à {{ imovel?.address?.street || '' }},
    {{ imovel?.address?.number || '' }},
    {{ imovel?.address?.zipCode ? (imovel?.address?.zipCode | mask: '00000-000') : '' }},
    {{ imovel?.address?.city || '' }},
    telefone: {{ conjuge?.phones?.cellphone ? (conjuge.phones.cellphone | mask: '(00) 00000-0000') : ''}},
    E-mail: {{conjuge?.email || ''}}
  </p>

  <p>
    <strong><u>OUTORGADO:</u> USU CAMPEÃO INCORPORAÇÃO, LOTEAMENTO E URBANIZAÇÃO SOCIAL LTDA.</strong>, pessoa jurídica
    de direito privado, inscrita no CNPJ/MF sob o nº 36.174.049/0001-08, com sede na cidade de São Paulo, Estado de São
    Paulo, na Rua Cláudio Soares, 72, cj 615, Pinheiros, CEP 05422-030, na cidade de São Paulo, Estado de São Paulo, e
    filial a Rua José Rodrigues Pereira 524, Salas 204-208, Condomínio Datasinc, Buritis, Belo Horizonte – MG, com
    endereço eletrônico contato&#64;usucampeao.com.br, telefone 0800 591 1328.
  </p>

  <p>
    <strong>PODERES:</strong> para isoladamente ou em conjunto, representar o(s) outorgante(s) e defender seus
    interesses, com os poderes especiais para nos termos da Lei nº 13.465/17, propor, requerer e assinar requerimentos
    de instauração de (REURB) “S”/“E”, junto ao município competente, referente ao imóvel localizado no cadastro anexo
    deste mandato, podendo ainda, apresentar à qualquer órgão da administração pública direta ou indireta e ao CARTÓRIO
    DE REGISTRO DE IMÓVEIS, realizar defesas e recursos, impetrar medidas preventivas ou assecuratórias, transigir,
    firmar compromissos ou acordos, atualizar, alterar e corrigir cadastro, requerer intimações, requerer o registro da
    CRF junto ao Oficial de Registro de Imóveis,
    <ng-container *ngIf="cadastro?.averbacao">
      solicitar a declaração de existência de edificação, requerer a averbação da construção na matrícula,
    </ng-container> acompanhar processos em todos os seus termos e instâncias
    administrativas com o fito do bom e fiel cumprimento do presente mandato, podendo substabelecer com ou sem reserva
    de iguais poderes e, ainda, usar de todos os meios admitidos em direito, para o bom e fiel cumprimento do presente
    mandato.
  </p>

  <p>{{ cadastro?.projetoMunicipio }}, {{cadastro?.contractDate | date: 'longDate'}}.</p>

  <div class="procuracao__bloco-assinatura">
    <div class="procuracao__linha-assinatura"></div>
    <b>OUTORGANTE 1</b>
  </div>

  <div class="procuracao__bloco-assinatura" *ngIf="mostrarDadosConjuge">
    <div class="procuracao__linha-assinatura"></div>
    <b>OUTORGANTE 2</b>
  </div>
</div>